import * as Stimulus from "@hotwired/stimulus"

/**
 * Controls dismissable page elements. Elements are removed
 * from the DOM when the dismiss action is fired.
 **/
export class DismissableController extends Stimulus.Controller {
    static classes = ["pointer"];

    connect() {
        this.element.classList.add(this.pointerClass);
    }
    dismiss(e) {
        this.element.remove();
    }
}
